import React, { Component } from "react";

import Footer from "./shared/Footer";
import LocalizedLink from "../containers/LocalizedLink";

import ImageMGMCasino_1 from "../images/realisations/projet_mgm-casino/01-MGM_Casino_Fish_Restaurant.jpg";
import ImageMGMCasino_2 from "../images/realisations/projet_mgm-casino/02-MGM_Casino_Fish_Restaurant.jpg";
import ImageMGMCasino_3 from "../images/realisations/projet_mgm-casino/03-MGM_Casino_Fish_Restaurant.jpg";
import ImageMGMCasino_4 from "../images/realisations/projet_mgm-casino/04-MGM_Casino_Fish_Restaurant.jpg";
import ImageMGMCasino_5 from "../images/realisations/projet_mgm-casino/05-MGM_Casino_Fish_Restaurant.jpg";
import { patternsByIds } from "../constants/patterns";
import { surfacesByIds } from "../constants/surfaces";

class RealisationMgmCasino extends Component {
  render() {
    return (
      <React.Fragment>
        <section
          className="grid grid--2 grid--fixed"
          style={{ marginTop: "55px" }}
        >
          <LocalizedLink className="grid__item" to="/realisations">
            <div className="grid__item-title">
              <i className="f7 i-arrow-left-light" /> {this.props.t("common:realisationsBackbutton")}
            </div>
          </LocalizedLink>
          <div className="grid__item">
            <div className="grid__item-title-nohover font-bold">
              MGM Casino, FISH by José Andres Restaurant - National Harbor
            </div>
          </div>
        </section>

        <section className="projects">
          <div
            className="projects__item projects__item--100"
            style={{ backgroundImage: `url(${ImageMGMCasino_1})` }}
          >
            <div className="projects__item-label">
                {this.props.t("common:labelArchitect")} : Smith Group San Francisco et Smith Group DC
            </div>
          </div>

          <div
            className="projects__item projects__item--50"
            style={{ backgroundImage: `url(${ImageMGMCasino_2})` }}
          >
            <div className="projects__item-label">
                {this.props.t("common:labelArchitect")} : Smith Group San Francisco et Smith Group DC
            </div>
          </div>
          <div
            className="projects__item projects__item--50 bl"
            style={{ backgroundImage: `url(${ImageMGMCasino_3})` }}
          >
            <div className="projects__item-label">
                {this.props.t("common:labelArchitect")} : Smith Group San Francisco et Smith Group DC
            </div>
          </div>

          <div
            className="projects__item projects__item--50"
            style={{ backgroundImage: `url(${ImageMGMCasino_4})` }}
          >
            <div className="projects__item-label">
                {this.props.t("common:labelSurface")} : Oberflex - {surfacesByIds[57]["title_"+this.props.lng]} {/*Sycomore*/}
            </div>
          </div>
          <div
            className="projects__item projects__item--50 bl"
            style={{ backgroundImage: `url(${ImageMGMCasino_5})` }}
          >
            <div className="projects__item-label">
            {this.props.t("common:labelPattern")} : {this.props.t("common:labelCollections55")} - {patternsByIds[16]["title_"+this.props.lng]}{" "}{/* Collections 5.5 - Chair de poule*/}
            </div>
          </div>
        </section>

        <section className="w-100 pv7">
          <div className="w-100 tc">
            <LocalizedLink className="button button--large" to="/realisations/mcdonalds-champs-elysees">
              <i className="button__icon i-arrow-left-light" />
              &nbsp;{this.props.t('common:labelPreviousProject')}
            </LocalizedLink>

            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

            <LocalizedLink className="button button--large" to="/create">
            {this.props.t('common:labelCreateYourModel')}&nbsp;
              <i className="button__icon i-arrow-right-light" />
            </LocalizedLink>

            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

            <LocalizedLink className="button button--large" to="/realisations/ministere-des-affaires-etrangeres">
              {this.props.t('common:labelNextProject')}&nbsp;
              <i className="button__icon i-arrow-right-light" />
            </LocalizedLink>
          </div>
        </section>
        <Footer t={this.props.t} />
      </React.Fragment>
    );
  }
}

export default RealisationMgmCasino;



// WEBPACK FOOTER //
// ./src/components/RealisationMgmCasino.js